<div class="upgrade-pricing-modal">
  <div class="modal-header">
    <h4 class="modal-title">{{ "Upgrade to {{0}}" | translate: { "0": upgradePricing.newPlan.name } }}</h4>
    <button (click)="cancel()" class="btn-close" aria-label="Close" type="button"></button>
  </div>

  <div class="modal-body">
    <div *ngIf="!upgradePricing.canUpgrade" class="alert alert-warning">
      <fa-icon [icon]="['fas', 'exclamation-triangle']" class="me-2"></fa-icon>
      {{ upgradePricing.error || ("Upgrade not available at this time" | translate) }}
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger">
      <fa-icon [icon]="['fas', 'exclamation-circle']" class="me-2"></fa-icon>
      {{ errorMessage }}
      <p class="mb-0 mt-2">
        <small
          [innerHTML]="
            'If this problem persists, please contact support at {{0}}.'
              | translate
                : {
                    '0': '<a href=&quot;mailto:support&#64;astrobin.com&quot;>support&#64;astrobin.com</a>'
                  }
          "
        ></small>
      </p>
    </div>

    <div *ngIf="upgradePricing.canUpgrade">
      <!-- Plans comparison - side by side -->
      <div class="plans-comparison mb-5">
        <div class="plan-card current-plan">
          <div class="plan-name">{{ upgradePricing.currentPlan.name }}</div>
          <div class="plan-details">
            <div class="days-remaining">
              {{ upgradePricing.currentPlan.timeRemaining.days }} {{ "days remaining" | translate }}
            </div>
            <div class="plan-price">
              {{
                upgradePricing.currentPlan.fullPrice
                  | currency: upgradePricing.currency : "symbol" : "1.2-2" : translateService.currentLang
              }}/{{ upgradePricing.currentPlan.recurringUnit | translate }}
            </div>
          </div>
        </div>

        <div class="arrow-separator">
          <fa-icon [icon]="['fas', 'chevron-right']" class="chevron-right"></fa-icon>
          <fa-icon [icon]="['fas', 'chevron-down']" class="chevron-down"></fa-icon>
        </div>

        <div class="plan-card new-plan">
          <div class="plan-name">{{ upgradePricing.newPlan.name }}</div>
          <div class="plan-details">
            <div class="plan-price">
              {{
                upgradePricing.newPlan.fullPrice
                  | currency: upgradePricing.currency : "symbol" : "1.2-2" : translateService.currentLang
              }}/{{ upgradePricing.newPlan.recurringUnit | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Due now section -->
      <div class="due-now-section">
        <h6 class="section-title">{{ "Due now" | translate }}</h6>

        <div class="proration-items">
          <div class="proration-item">
            <span>{{ "Prorated refund for unused time" | translate }}</span>
            <span class="amount credit-amount">
              -{{
                upgradePricing.proration.creditAmount
                  | currency: upgradePricing.currency : "symbol" : "1.2-2" : translateService.currentLang
              }}
            </span>
          </div>
          <div class="proration-item">
            <span>{{ "Prorated charge for the new plan" | translate }}</span>
            <span class="amount charge-amount">
              +{{
                upgradePricing.proration.chargeAmount
                  | currency: upgradePricing.currency : "symbol" : "1.2-2" : translateService.currentLang
              }}
            </span>
          </div>
        </div>

        <div class="total-due">
          <span class="total-amount">
            {{
              upgradePricing.summary.immediateCharge
                | currency: upgradePricing.currency : "symbol" : "1.2-2" : translateService.currentLang
            }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="upgradePricing.canUpgrade"
      [class.loading]="loading"
      [disabled]="loading"
      (click)="confirmUpgrade()"
      class="btn btn-primary"
      type="button"
    >
      <ng-container *ngIf="!loading">
        {{ "Upgrade for {{0}}" | translate: { "0": (upgradePricing.summary.immediateCharge | currency:
        upgradePricing.currency : 'symbol' : '1.2-2' : translateService.currentLang) } }}
      </ng-container>
      <ng-container *ngIf="loading">
        <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true" class="me-2"></fa-icon>
        {{ "Processing..." | translate }}
      </ng-container>
    </button>
  </div>
</div>
